import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import validate from './Validations/submitValidationsVineyardsForm';
import renderField from './RenderField';
import Section from './Section.js'
import {FormattedHTMLMessage} from 'react-intl';
import TopScrolleable from './TopScrolleable.js';
import CustomSpinner from './CustomSpinner';
import CustomAlert from '../components/CustomAlert.js';
import SaveStepButton from './SaveStepButton';
import { WAButton } from '../components/Button.js';
import withAuthControl from '../auth/Auth.js';

require(`../assets/${process.env.PAGE}/css/components/VineyardsForm.css`);

const renderVineyards = ({ fields, meta: { touched, error, submitFailed } }) => (
  <div>
        <div className="text-center">
            <button className="btn btn-add-vineyard" type="button" onClick={() =>  fields.push({})}>+ Agregar Viñedo</button>
        </div>
        <div style={{height:'20px'}}></div>
    <div className="pvc-form" >
      {fields.map((vineyard, index) => (
        <div key={index}>
          <div className="delete-vineyard-btn" onClick={() => fields.remove(index)}>x</div>
          <h4>{index + 1}° Viñedo</h4>
          <Field className="form-control" name={`${vineyard}.vineyard_id`} autoComplete="off" component={renderField} type="text" label="Ingresá el código de viñedo (Ej:A00000)" />
          <div style={{height:'10px'}}></div>
        </div>
      ))}
    </div>
  </div>
);

let VineyardsForm = (props, context) => {
  const { handleSubmit, submitting, error } = props;

  return (
    <Section className="intro_form">
                    <div className="row">
                        <div className="pd-content-left col-md-5 col-lg-5 text-center">
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                            <FormattedHTMLMessage id="app.step_vineyards" description="Vineyards info"/>
                            <div className="show-desktop">
                              <WAButton phone={context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                              <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                              <SaveStepButton/>
                            </div>
                        </div>
                        <div style={{height:'30px'}}></div>
                        <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                            <form onSubmit={handleSubmit}>
                            {props.isLoading &&  <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            { error && (<CustomAlert bsStyle="danger" message={error}/>)}
                            <FieldArray name="vineyards" component={renderVineyards} />
                            <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                    </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                          <WAButton phone={context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                          <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                          <SaveStepButton/>
                        </div>
                        </div>
                    </div>
                </Section>
  );
};

VineyardsForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

VineyardsForm = TopScrolleable(VineyardsForm);

VineyardsForm = reduxForm({
  form: 'VineyardsForm', // a unique identifier for this form
  validate,
  initialValues: {
    "vineyards": [
              {}
               ]
                 }
})(VineyardsForm);

VineyardsForm = withAuthControl(VineyardsForm);

export default VineyardsForm;


/** WEBPACK FOOTER **
 ** ./src/components/VineyardsForm.js
 **/